<template>
    <div class="table" :class="[{ 'expanded': data.length <= limitLength, 'table-responsive': responsive }]">
        <slot ></slot>
    </div>
</template>

<script>
    export default {
        props: {
            data: { type: Array, required: true },
            limitLength: { type: Number, default: 3 },
            responsive: { type: Boolean, default: false }
        }
    }
</script>

<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 100px !important;
}
</style>